import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { PaymentStatus } from '../../domain/models/intent';
import { PaymentDone } from '../../domain/models/payment-done';
import { Table } from '../../domain/models/table';
import { PaymentService } from '../../domain/services/payment.service';
import { TableService } from '../../domain/services/table.service';
import { ReceiptComponent } from '../show-receipts/receipt/receipt.component';

import { StatusMessageComponent } from '../../components/status-message/status-message.component';

@Component({
  selector: 'app-payment-finished',
  imports: [
    CommonModule,
    StatusMessageComponent,
    ReceiptComponent,
  ],
  templateUrl: './payment-finished.component.html',
  styleUrl: './payment-finished.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PaymentFinishedComponent {
  uuid: string;
  intentStatus: PaymentStatus;
  tableSubscription: Subscription;
  lastPaid: PaymentDone | undefined;
  openReceipt: boolean = false;
  googleBusinessUrl: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private paymentService: PaymentService,
    private tableService: TableService,
  ) {
    this.uuid = String(this.route.snapshot.paramMap.get('uuid'))
    this.tableService.loadTable(this.uuid);
    this.intentStatus = this.paymentService.getIntentStatus();

    const intentUuid = this.paymentService.getPaymentUuid();

    // if (!this.intentStatus) {
    //   this.router.navigate(['..'], { relativeTo: this.route });
    // }

    if(!this.tableSubscription) {
      this.tableSubscription = this.tableService.$openedTable.subscribe((table: Table | null) => {

        if(table) {
          if(table.payments?.length && intentUuid) {
          this.lastPaid = table.payments.find((payment: PaymentDone) => payment.paymentUuid == intentUuid);
        }

          this.googleBusinessUrl = table.installation.googleBusinessUrl || '';
        }
      })
    }
  }

  handleOpenReceipt() {
    this.router.navigate([`${this.uuid}/receipts`])
  }

  handleEvaluateExperience() {
    if (!this.googleBusinessUrl) {
      return;
    }

    window.open(this.googleBusinessUrl, '_blank');
  }

  goToStart() {
    if (this.intentStatus == 'PAID') {
      this.router.navigate(['..'], { relativeTo: this.route });
    } else if(this.intentStatus == 'CANCELLED') {
      this.router.navigate(['../details'], { relativeTo: this.route });
    }
  }
}
